import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";
import moment from "moment";

let getSurveySourceToken;
export const getSurvey = ({
  token,
  communityId,
  isClient,
  sourceToken = null
}) => {
  getSurveySourceToken = updateSourceToken(getSurveySourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/survey/survey`;
  //const requestUrl = `http://api.v2.tamtam.pro/survey/survey`;

  const fields = ["*", "latestInstance", "response", "dimensions"];
  /*const d = new Date();
  const month = d.getMonth() < 10 ? `0${d.getMonth()}` : d.getMonth();
  const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();*/

  const filter = [
    {
      property: "date",
      value: moment().format(),
      operator: "eq"
    },
    {
      property: "type",
      value: "PORTAL",
      operator: "eq"
    },
    {
      property: "organization.id",
      value: communityId,
      operator: "eq"
    },
    {
      property: "scope",
      value: ["ALL", isClient ? "CLIENTS" : "COLLABORATORS"],
      operator: "in"
    }
  ];

  const sort = [];
  return axios
    .get(requestUrl, {
      cancelToken: getSurveySourceToken.token,
      params: {
        access_token: token,
        //access_token: "463e605e5e9aaa3e98079ed70fc5aac4210208d5",
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        filter: JSON.stringify(filter)
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getUserResponse = ({
  token,
  instanceId,
  sourceToken = null,
  communityId
}) => {
  const requestUrl = `${TTP_API_URL}/survey/response/${instanceId}`;
  //const requestUrl = `http://api.v2.tamtam.pro/survey/response/${instanceId}`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        //access_token: "463e605e5e9aaa3e98079ed70fc5aac4210208d5",
        organization: communityId
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const sendChoice = ({
  token,
  instanceId,
  questionId,
  user,
  choice,
  communityId
}) => {
  const requestUrl = `${TTP_API_URL}/survey/response`;
  //const requestUrl = "http://api.v2.tamtam.pro/survey/response";

  let formData = new FormData();
  formData.append("access_token", token);
  //formData.append("access_token", "463e605e5e9aaa3e98079ed70fc5aac4210208d5");
  formData.append("instance", instanceId);
  formData.append("organization", communityId);
  formData.append("user", user);
  formData.append("answers[0][question]", questionId);
  formData.append("answers[0][resourceType]", "multipleChoice");
  formData.append("answers[0][choices][0]", choice);

  return axios.post(requestUrl, formData);
};

export const getSurveyStats = ({ token, instanceId, questionId }) => {
  const requestUrl = `${TTP_API_URL}/survey/result/question/stats/${questionId}`;
  //const requestUrl = `http://api.v2.tamtam.pro/survey/result/question/stats/${questionId}`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        //access_token: "463e605e5e9aaa3e98079ed70fc5aac4210208d5",
        instanceId: instanceId
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/survey.js